import type {
  CourseEmailPreference,
  GlobalChannelNotificationPreferences,
  GlobalNotificationPreferences,
  NotificationPreferenceChannel,
} from 'bundles/account-settings/types/EmailPreferences';

export const composeGlobalNotificationPreferencesByChannel = (
  preferences: GlobalChannelNotificationPreferences,
  channel: NotificationPreferenceChannel
) => {
  return Object.fromEntries(
    Object.entries(preferences)
      .map(([key, value]) => [key, value[channel]])
      .filter(([_, value]) => value !== undefined)
  ) as GlobalNotificationPreferences;
};

export const getEnabledNotificationCount = (value: CourseEmailPreference['value']) =>
  [value.announcements, value.reminders, value.discussionForums].filter(Boolean).length;
